module.exports = __webpack_public_path__ + "static/assets/86812e6ba5a61f6476cfb428fab4faa3.svg";